export default __webpack_public_path__ + "static/media/journey.54957b8f.svg";